import { render } from "./LbrxAboutPopup.vue?vue&type=template&id=349d77ee&scoped=true"
import script from "./LbrxAboutPopup.vue?vue&type=script&lang=js"
export * from "./LbrxAboutPopup.vue?vue&type=script&lang=js"

import "./LbrxAboutPopup.vue?vue&type=style&index=0&id=349d77ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349d77ee"]])

export default __exports__